import { useEffect, useState } from "react";
import { Switch } from "@mui/material";
import { connect } from "react-redux";
import toast from "react-hot-toast";

import { UpdateAppSettings } from "../../../redux/v2/user/actions";
import { callSocket } from "../../../utils/socket";

import PaddedContentArea from "../../../common/PaddedContentArea";

import "./style.css";
import { delay } from "../../../utils";

function Notification(props) {

    const [isNotifOptedIn, setIsNotifOptedIn] = useState(null);
    const [delayRef, setDelayRef] = useState(null);

    useEffect(() => {
        setIsNotifOptedIn(localStorage.getItem("notification-opted-in") == 1);
    }, []);

    const notifSwitch = (bool) => {
        setIsNotifOptedIn(bool);
        localStorage.setItem("notification-opted-in", bool ? 1 : 0)
    }

    const SavingLoader = () => {
        clearTimeout(delayRef);
        toast.dismiss();

        let tempT = toast.loading("Updating Settings.");

        setDelayRef(delay(() => {
            toast.success("Settings Updated!", { id: tempT });
        }, 3000))
    }


    return (
        <PaddedContentArea>
            <div className="flex-c">
                <div id="settings-notification">
                    <div id="sn-header">
                        <h4>Notifications</h4>
                        <p>Stay up to date and in the know to keep yourself moving and feeling your best.</p>
                    </div>

                    <div id="sn-options">
                        <div className="sn-option">
                            <div className="sn-option-label">
                                <h5>In-app Notifications</h5>
                                <p>
                                    Tips, insights, suggestions, reminders, and more.
                                </p>
                            </div>
                            <div className="sn-option-toggler">
                                <Switch checked={isNotifOptedIn} onChange={(e) => {
                                    SavingLoader();
                                    if (!isNotifOptedIn) {
                                        callSocket("/interact-native-component", { type: "notification" });
                                        notifSwitch(true);
                                    } else {
                                        callSocket("/interact-native-component", { type: "disable-notification" });
                                        notifSwitch(false);
                                    }
                                }} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </PaddedContentArea>
    );
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    UpdateAppSettings,
})(Notification);